import { CurrencyCode } from '@payflip/utils';

export function toDisplayCurrency(
  value: number,
  currency: CurrencyCode
): string {
  return Number(value).toLocaleString('fr-BE', {
    currency,
    currencyDisplay: 'code',
    style: 'currency'
  });
}
